import React, { useMemo } from 'react';
import styled from 'styled-components';
import { sanitizeStudentHtml } from './seedSanitize';

type Props = {
	/** The stored answer: always HTML (the student backend normalises every
	 * text answer on write; legacy plain text was converted once). */
	html: string | null | undefined;
	className?: string;
};

/**
 * Renders a student's text answer for a grader, sanitized with the student
 * allowlist. Quill's class attributors (`ql-align-*`, `ql-direction-rtl`, …)
 * are styled by the globally mounted QuillContentStyles.
 */
const StudentAnswerHtml: React.FC<Props> = ({ html, className }) => {
	const clean = useMemo(() => sanitizeStudentHtml(html), [html]);
	return <Body className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

const Body = styled.div`
	white-space: pre-wrap;
	overflow-wrap: anywhere;
	text-align: start;
`;

export default StudentAnswerHtml;
